export const CONS = {
  title: 'Locked Out',
  header: 'Your answers don’t match our records',
  subHeader: 'Here’s what you can do next:',
  listItem1: 'Wait 24 hours to try again',
  listItem2: 'Call Customer Care and tell them that you have a',
  PM2: 'PM2 error.',
  customerCare: 'Call 1-888-607-4287',
  TTY: 'TTY: 711'
};

// Translation configuration for lockout page
export const LOCKOUT_TRANSLATION_CONFIG = [{ key: 'CONS', value: CONS, message: JSON.stringify(CONS) }];

// Helper function to process translated items
export const processLockoutTranslations = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  const parsedCons = translatedItems[JSON.stringify(CONS)];
  let consTranslated = CONS;

  if (parsedCons) {
    try {
      consTranslated = typeof parsedCons === 'string' ? JSON.parse(parsedCons) : parsedCons;
    } catch {
      consTranslated = CONS;
    }
  }

  return {
    CONS: consTranslated
  };
};
